<template>
  <div class="campaign-main-section">
    <div class="ms-filter">
      <ms-form-filter
        :filters="filters"
        default-search="name"/>
    </div>
    <ms-grid
      :data="items"
      :columns="columns"
      :options="options"
      :pager="pager"
      @notFoundItem="addNewCampaing">
      <div
        slot="name"
        slot-scope="{row}">
        <span class="title">{{ row.name }}</span>
        <br>
        <span class="description">{{ row.description }}</span>
      </div>
      <div
        slot="status"
        slot-scope="{row}">
        <el-tag
          v-if="row.status === 'published'"
          type="success"
          size="small">
          <strong>PUBLICADO</strong>
        </el-tag>
        <el-tag
          v-if="row.status === 'rejected'"
          type="danger"
          size="small">
          <strong>RECHAZADO</strong>
        </el-tag>
        <el-tag
          v-if="row.status === 'pending'"
          type="info"
          size="small">
          <strong>PENDIENTE</strong>
        </el-tag>
        <el-button
          v-if="row.status === 'pre-approved'"
          type="primary"
          @click="preApproved(row)">
          PRE-APROBADO
        </el-button>
      </div>
    </ms-grid>

    <campaign-preview-approve
      v-if="showApprovePanel"
      :profile="profile"
      :item-campaign="campaignSelected"/>
    <campaign-create-view
      v-if="showCampaignEditPanel"
      :old="campaignSelected"
      @closeCampaign="closeCampaign"/>
  </div>
</template>

<script>
import CampaignPreviewApprove from '@/modules/campaigns/campaign-preview-approve'
import MsFormFilter from '@/components/_shared/ms-form-filter'
import CampaignCreateView from '@/views/app/campaigns/campaign-create-view'
import MsGrid from '@/modules/grid/ms-grid'
import CampaignsGuards from '@/guards/campaigns.guards'
import FiltersCampaign from '@/utilis/filters-campaign'
export default {
  name: 'CampaignApprove',
  components: {
    MsFormFilter,
    CampaignPreviewApprove,
    CampaignCreateView,
    MsGrid
  },
  data () {
    return {
      campaignSelected: null,
      filters: FiltersCampaign,
      columns: [
        {
          property: 'name',
          label: 'TÍTULO',
          align: 'center'
        },
        {
          property: 'created',
          label: 'CREADO POR',
          align: 'center'
        },
        {
          property: 'startDate',
          label: 'FECHA DE INICIO',
          align: 'center',
          type: 'date'
        },
        {
          property: 'endDate',
          label: 'FECHA DE CULMINACIÓN',
          align: 'center',
          type: 'date'
        },
        {
          property: 'dealerName',
          label: 'DISTRUIBUIDOR',
          align: 'center'
        },
        {
          property: 'status',
          label: 'ESTATUS',
          align: 'center'
        }
      ],
      options: {
        selectable: false
      },
      showCampaignEditPanel: false
    }
  },
  computed: {
    items () {
      return this.$store.getters['campaigns/items']
    },
    pager () {
      return this.$store.getters['campaigns/pagination']
    },
    showApprovePanel () {
      return this.$store.getters['app/showApprovePanel']
    },
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  methods: {
    addNewCampaing () {
      this.showCampaignEditPanel = true
      this.$emit('addCampaign')
      this.$store.dispatch('app/toggleCampaignPanel')
    },
    preApproved (item) {
      this.campaignSelected = item
      this.$store.dispatch('app/toggleApprovePanel')
    },
    closeCampaign (value) {
      if (value) {
        this.showCampaignEditPanel = false
        this.$store.dispatch('app/toggleCampaignEditPanel')
      }
    }
  },
  beforeRouteUpdate: CampaignsGuards.allCampaigns
}
</script>

<style scoped lang="scss">
  .campaign-main-section{
    padding: 20px;
    background-color: #ffffff;
    overflow: auto;
    min-height: 70vh;
    .ms-filter{
      margin: -20px -20px 0 -20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/modules/campaigns/_shared/campaign-approve.vue